<template>
  <SnackBar ref="snackbar" />
  <v-dialog v-model="dialog" width="680">
    <template #activator="{ props }">
      <v-btn
        color="#004984"
        v-bind="props"
        variant="outlined"
        style="background: white"
      >
        Atualizar Tarefa
        <v-icon right style="margin-left: 5px">mdi-update</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h5">Atualizar Tarefa</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="9">
              <v-text-field
                v-model="nome"
                variant="underlined"
                label="Nome da tarefa*"
                required
                hint="Utilize uma descrição de no máximo 68 caracteres"
                counter
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="8" md="3">
              <v-select
                v-model="pontos"
                variant="underlined"
                label="Story Points*"
                :items="storypoints"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="8" md="3">
              <v-select
                v-model="this.prioridade"
                variant="underlined"
                label="Prioridade*"
                :items="prioridades"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="8" md="9">
              <v-select
                v-model="this.tipo"
                variant="underlined"
                label="Tipo de Tarefa*"
                :items="tipos"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="descricao"
                variant="underlined"
                no-resize
                rows="4"
                label="Descrição*"
                hint="Utilize uma descrição de no máximo 255 caracteres"
                counter
              ></v-textarea>
            </v-col>
            <v-col v-if="this.tipo == 'IMPLEMENTACAO'" cols="12" sm="8" md="9">
              <v-select
                v-model="this.tipoImplementacao"
                variant="underlined"
                label="Tipo de Implementação*"
                :items="tiposImplementacao"
              ></v-select>
            </v-col>
            <v-col v-if="this.tipo == 'IMPLEMENTACAO'" cols="12" sm="8" md="9">
              <v-select
                v-model="csuSelecionados"
                variant="underlined"
                :items="casosDeUsos"
                label="Casos de uso*"
                multiple
              >
              </v-select>
            </v-col>
          </v-row>
        </v-container>
        <small>*Campos Obrigatórios</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue-darken-1" variant="text" @click="close">
          Cancelar
        </v-btn>
        <v-btn
          color="blue-darken-1"
          variant="text"
          @click="atualizarTask(this.idTarefa)"
        >
          Atualizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/* eslint-disable */
import axios from 'axios';
import store from '../../store/store';
import SnackBar from '../SnackBar.vue';
const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  /* eslint-disable*/
  /**
   * Objeto de dados para componente.
   * @typedef {Object} ComponentData
   * @property {boolean} dialog - Determina se a caixa de diálogo está aberta ou não.
   * @property {string} nome - O nome da tarefa.
   * @property {string} pontos - O número de pontos para a tarefa.
   * @property {string} prioridade - A prioridade da tarefa.
   * @property {string} tipo - O tipo da tarefa.
   * @property {string} tipoImplementacao - O tipo de implementação da tarefa.
   * @property {string} descricao - A descrição da tarefa.
   * @property {string} tarefaId - O ID da tarefa.
   * @property {Array} casosDeUsos - Uma matriz de casos de uso.
   * @property {Array} csuSelecionados - Uma matriz de casos de uso selecionados.
   * @property {Array} csuIds - Uma matriz de IDs de caso de uso.
   * @property {Array} items - Uma matriz de itens.
   * @property {Array} - Uma matriz de tipos de tarefas.
   * @property {Array} tiposImplementacao - Uma matriz de tipos de implementação.
   */

  /**
   * Dados do componente.
   * @type {ComponentData}
   */
  props: {
    idProjeto: {
      type: Number,
      default: null,
    },
    idTarefa: {
      type: Number,
      default: null,
    },
    task: {
      type: Object,
      required: true,
    },
  },
  emits: ['tarefa-atualizada'],
  mounted() {
    this.pegarProjeto();
    setTimeout(() => {
      this.nome = this.task.titulo;
      this.pontos = this.task.storypoint;
      this.prioridade = this.task.prioridade;
      this.tipo = this.task.tipo_tarefa;
      this.descricao = this.task.descricao;
    }, 1000);
  },
  components: {
    SnackBar,
  },
  data: () => ({
    dialog: false,
    nome: '',
    pontos: '',
    storypoints: ['0', '1/2', '1', '2', '3', '5', '8', '13', ' 20', '40', '?'],
    prioridade: '',
    prioridades: ['URGENTE', 'ALTA', 'MEDIA', 'BAIXA'],
    tipo: '',
    tipoImplementacao: '',
    descricao: '',
    tarefaId: '',
    casosDeUsos: [],
    csuSelecionados: [],
    csuIds: [],
    items: [],
    tipos: [
      'TECNICA',
      'DOCUMENTACAO',
      'IMPLEMENTACAO',
      'TESTE_INDEPENDENTE',
      'TESTE_EQUIPE',
    ],
    tiposImplementacao: ['FUNCIONALIDADE', 'TESTE_AUTOMATIZADO'],
  }),
  methods: {
    close() {
      this.dialog = false;
    },
    pegarProjeto() {
      axios
        .get(API_URL + '/tarefas/' + this.idTarefa, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          var idProjeto = response.data.tarefa.id_projeto;
          this.getCsu(idProjeto);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getCsu(idProjeto) {
      console.log(this.task);
      axios
        .get(API_URL + '/api/v1/productBacklog/projeto/' + idProjeto, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.items = response.data.useCases;
          console.log(this.items);
          this.listaCsu();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    listaCsu() {
      for (var i = 0; i < this.items.length; i++) {
        this.casosDeUsos.push(this.items[i].nome);
      }
    },
    pegaIdCsu() {
      for (var i = 0; i < this.csuSelecionados.length; i++) {
        for (var j = 0; j < this.items.length; j++) {
          if (this.csuSelecionados[i] == this.items[j].nome) {
            this.csuIds.push(this.items[j].id_caso_de_uso);
          }
        }
      }
    },
    atualizarTask(idTarefa) {
      this.close();
      const data = {
        titulo: this.nome,
        descricao: this.descricao,
        storypoint: this.pontos.toString(),
        prioridade: this.prioridade,
        tipo_tarefa: this.tipo,
        // TODO: Checar para time de req
        // id_projeto: parseInt(this.idProjeto),
        // id_dev: localStorage.getItem('idUsuario'),
      };

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };

      axios
        .put(API_URL + `/tarefas/${idTarefa}`, data, config)
        .then((response) => {
          if (this.tipo == 'IMPLEMENTACAO') {
            this.pegaIdCsu();
            const data = {
              tipo_implementacao: this.tipoImplementacao, // eslint-disable-line
              id_tarefa: idTarefa, // eslint-disable-line
              casosDeUsos: this.csuIds,
            };
            axios
              .post(API_URL + '/api/v1/implementacao/varios', data, config)
              .then((response) => {
                console.log(response.data);
                this.$refs.snackbar.showSuccessSnackbar(
                  'Concluído!',
                  'Implementacao ' + this.nome + ' atualizada com sucesso!'
                );
              })
              .catch((error) => {
                console.error(error);
                this.$refs.snackbar.showErrorSnackbar(
                  'Hm... Algo deu errado',
                  'Por algum motivo, não conseguimos atualizar sua tarefa. Verifique os dados e tente novamente.'
                );
              });
          } else if (response.data.msg) {
            this.$refs.snackbar.showSuccessSnackbar(
              'Concluído!',
              'Tarefa: ' + this.nome + ' atualizada com sucesso!'
            );
          } else {
            this.$refs.snackbar.showWarningSnackbar(
              'Concluído!',
              `${response.data.mensagem}`
            );
            setTimeout(() => {
              location.reload();
            }, 4000);
          }
          const tarefaAtualizada = {
            ...this.task,
            ...data,
          };
          this.$emit('tarefa-atualizada', tarefaAtualizada);
        })
        .catch((error) => {
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos atualizar sua tarefa. Verifique os dados e tente novamente.'
          );
        });
    },
  },
};
</script>
